var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.586 5.58592C15.7705 5.3949 15.9912 5.24253 16.2352 5.13772C16.4792 5.0329 16.7416 4.97772 17.0072 4.97542C17.2728 4.97311 17.5361 5.02371 17.7819 5.12427C18.0277 5.22484 18.251 5.37334 18.4388 5.56113C18.6266 5.74891 18.7751 5.97222 18.8756 6.21801C18.9762 6.4638 19.0268 6.72716 19.0245 6.99272C19.0222 7.25828 18.967 7.52072 18.8622 7.76473C18.7574 8.00874 18.605 8.22942 18.414 8.41392L17.621 9.20692L14.793 6.37892L15.586 5.58592V5.58592ZM13.379 7.79292L5 16.1719V18.9999H7.828L16.208 10.6209L13.378 7.79292H13.379Z",
    fill: "#252C32"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e390abca1fcbd976ff88dacebacef87c.svg";
export { ForwardRef as ReactComponent };